import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [ 'slot' ]

  connect() {
    this.element[this.identifier] = this
  }

  select(event) {
    if (this.slotTarget.disabled) {
      return false
    }

    const rows = Array.from(this.element.getElementsByTagName('tr'))

    rows.forEach(tr => {
      tr.classList.remove("selected")
    })

    const tr = event.target.closest('tr')
    if (tr) {
      tr.classList.add('selected')
      this.slotTarget.value = tr.dataset.slot

      $(this.slotTarget).trigger('change')
    }
  }

  change(_event) {
    var el = this.slotTarget
    var val = el.options[el.selectedIndex].value

    const rows = Array.from(this.element.getElementsByTagName('tr'))
    rows.forEach(tr => {
      tr.classList.remove('selected')
    })

    const tr = this.element.querySelector(`tr[data-slot="${val}"]`)

    if (tr) {
      tr.classList.add('selected')
    }
  }
}
